import { MedicationBasicData } from "~/common/types";

export const getSelectedMedication = (
  medicationId: string,
  medications?: MedicationBasicData[],
) => medications?.find(({ id }) => id === medicationId);
